import { EDITOR_MODE } from "@pathwright/blocks-engine"
import React from "react"
import Carousel from "./Carousel/Carousel"
import Grid from "./Grid/Grid"

const propsAreEqual = (prevProps, nextProps) => {
  if (nextProps.layout !== prevProps.layout) return false
  return true
}

const GalleryView = React.memo((props) => {
  const { layout } = props

  if (layout === "grid" || layout === "grid-2")
    return <Grid {...props} columns={layout === "grid-2" ? 2 : 3} />

  return <Carousel {...props} mode={EDITOR_MODE.VIEW} />
}, propsAreEqual)

export default GalleryView
